
export const getWishId = (state, props) => props.wishId;



// WEBPACK FOOTER //
// ./src/lib/commonSelectors.js